/**
 * @generated SignedSource<<72357ee5a956914819098da717edaead>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type StoreProductExpireBatchActionStatus = "COMPLETED" | "INFO" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type ProductExpireBatchAction_StoreProductExpireBatchAction$data = {
  readonly id: string;
  readonly label: string;
  readonly startAtDate: {
    readonly isoString: string;
    readonly timezone: string;
    readonly " $fragmentSpreads": FragmentRefs<"StoreRelativeZonedDate_StoreZonedDate">;
  };
  readonly status: StoreProductExpireBatchActionStatus;
  readonly " $fragmentType": "ProductExpireBatchAction_StoreProductExpireBatchAction";
};
export type ProductExpireBatchAction_StoreProductExpireBatchAction$key = {
  readonly " $data"?: ProductExpireBatchAction_StoreProductExpireBatchAction$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatchAction_StoreProductExpireBatchAction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductExpireBatchAction_StoreProductExpireBatchAction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "startAtDate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isoString",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timezone",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StoreRelativeZonedDate_StoreZonedDate"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StoreProductExpireBatchAction",
  "abstractKey": null
};

(node as any).hash = "625f4d3f5c4b383cdeba18841a735fd1";

export default node;
